module.exports = {
      id: "illustrations:AU02-usage",
      viewBox: "0 0 263 231",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#illustrations:AU02-usage",
      toString: function () {
        return this.url;
      }
    }